import {useMsal} from "@azure/msal-react";
import {useNavigate} from 'react-router-dom';
import {getAppClientId} from "../../../../config.env";
import Session from '../../../utils/Session';

const Home = () => {
  const key = getAppClientId();
  const loginRequest = {
    scopes: ["openid", "offline_access", "profile", `https://infixusersb2ctest.onmicrosoft.com/${key}/access_as_user`]
  };
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).then((response) => {
      const accessToken = response.accessToken;
      const contactInfo = response.account.username;
      Session.setUserType('poa');
      Session.setPoaAccessToken(accessToken);
      const ticket = {accessToken };
      const customer = { email: contactInfo };
      Session.set(ticket, customer);
      navigate('/triageList');
    }).catch((error) => {
      console.error(error);
    });
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-xl font-semibold mb-6">
          Please select preferred login method
        </h1>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <a
            href="/login"
            className="px-6 py-3 bg-blue-500 text-white font-medium rounded-md shadow-md hover:bg-blue-600 transition"
          >
            Login as Patient
          </a>
          <a
            onClick={()=>{ handleLogin()  }}
            className="px-6 py-3 bg-green-500 text-white font-medium rounded-md shadow-md hover:bg-green-600 transition"
          >
            Login as POA
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
